<template>
  <div class="departmentDetail">
    <div class="name">
      <span>{{ formBase.name }}</span>
    </div>
    <el-tabs
      v-model="activeName"
      @tab-click="handleClick"
      v-if="departmentName !== ''"
    >
      <el-tab-pane label="基本信息" name="first" v-if="!isRootDepart">
        <el-button
          type="primary"
          size="small"
          class="editDepart"
          v-show="!isEdit"
          @click="editDepart"
        >
          编辑
        </el-button>
        <el-form
          :model="formBase"
          :rules="rules"
          ref="formBase"
          label-width="100px"
        >
          <el-form-item label="部门名称" prop="name">
            <el-input
              v-model="formBase.name"
              :disabled="!isEdit"
              :maxlength="32"
              :placeholder="isEdit ? '请输入部门名称' : ''"
            ></el-input>
          </el-form-item>
          <el-form-item label="父级部门" prop="superName">
            <el-select
              :disabled="!isEdit"
              ref="departSelect"
              class="departSelect"
              popper-class="departSelect"
              @visible-change="visibleChange"
              v-model="formBase.superName"
              placeholder="请选择父级部门，支持搜索查找"
              filterable
              :filter-method="filterMethod"
            >
              <el-option
                :value="selectOption.value"
                :label="selectOption.label"
              >
                <el-tree
                  class="selectDepartTree"
                  ref="departTree"
                  :data="department"
                  show-checkbox
                  node-key="id"
                  :highlight-current="true"
                  :expand-on-click-node="false"
                  :check-on-click-node="true"
                  :default-expand-all="true"
                  :check-strictly="true"
                  :props="defaultProps"
                  :filter-node-method="filterNode"
                  @node-click="handleNodeClick"
                >
                </el-tree>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <div class="footer" v-show="isEdit">
              <el-button type="primary" @click="submitForm">确 定</el-button>
              <el-button @click="handleCancel">取 消</el-button>
            </div>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="成员信息" name="second">
        <div class="authTip">
          <i class="icon icon-authTip"></i>
          <div>
            <p>{{ tip1 }}</p>
            <p>{{ tip2 }}</p>
          </div>
        </div>
        <div class="row-one">
          <el-button
            type="primary"
            size="small"
            class="setDepart"
            @click="setDepart"
          >
            设置部门
          </el-button>
          <Search
            placeholder="支持搜索账户名/邮箱"
            @handleSearch="handleSearch"
            ref="search"
          ></Search>
        </div>
        <el-table
          :data="tableData"
          tooltip-effect="light"
          style="width: 100%"
          ref="account"
          @selection-change="handleAccountSelectionChange"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column
            label="账户名"
            prop="accountName"
            width="240"
            :show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column
            label="姓名"
            prop="name"
            width="240"
            :show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column
            label="电子邮箱"
            prop="email"
            width="240"
            :show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column
            label="手机号码"
            prop="phone"
            :show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column
            label="部门"
            prop="department"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <span>
                {{ formatDepart(scope.row.department) }}
              </span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          layout="total, prev, pager, next"
          :page-size="pageSize"
          :current-page.sync="page"
          :total="total"
          @current-change="pageChange"
        >
        </el-pagination>
      </el-tab-pane>
      <el-tab-pane label="授权信息" name="third">
        <div class="authTip">
          <i class="icon icon-authTip"></i>
          <div>
            <p>{{ tip3 }}</p>
          </div>
        </div>
        <AuthClientRoles
          ref="AuthClientRoles"
          :tableDataClient="tableDataClient"
          :tableDataAllClient="tableDataAllClient"
          @postDepartClients="departClients"
          @putDepAuthCliRoles="depAuthCliRoles"
          :showTips="false"
        ></AuthClientRoles>
      </el-tab-pane>
    </el-tabs>
    <DialogSetDepart
      ref="dialogSetDepart"
      :selectAccount="selectAccount"
      :department="setDepartmentData"
      @setDepartment="setDepartment"
    ></DialogSetDepart>
  </div>
</template>

<script>
import APIS from "@/apis/department.js"
import Search from "@/components/common/Search.vue"
import DialogSetDepart from "@/components/common/Dialog/setDepart.vue"
import AuthClientRoles from "@/components/department/AuthClientRole.vue"
export default {
  components: {
    Search,
    DialogSetDepart,
    AuthClientRoles
  },
  data() {
    return {
      breadcrumb: [
        {
          label: "部门管理",
          url: "/department"
        },
        {
          label: "部门详情"
        }
      ],
      departmentName: "",
      isEdit: false,
      formBase: {
        name: "",
        superName: ""
      },
      rules: {
        name: [{ required: true, message: "请输入部门名称", trigger: "blur" }],
        superName: [
          { required: true, message: "请输入父级部门", trigger: "blur" }
        ]
      },
      tableData: [],
      tableDataClient: [],
      activeName: "first",
      tableDataAllClient: [],
      selectedClient: [], //选中要分配的应用
      department: [],
      cascaderProps: {
        checkStrictly: true,
        value: "id",
        label: "name",
        children: "subGroups",
        emitPath: false,
        disabled: "isDisabled" // 之所以重新命名，是为了不影响tree组件的数据
      },
      realmName: this.$realm,
      preParams: null,
      userIds: [],
      remDepartIds: [],
      addDepartIds: [],
      isRootDepart: false,
      selectAccount: [],
      selectOption: {
        value: "",
        label: ""
      },
      defaultProps: {
        children: "subGroups",
        label: "name"
      },
      setDepartmentData: [], // 给设置部门中的数据
      pageSize: 10,
      total: 0,
      page: 1,
      tip1: "部门成员包含其下级部门所有成员，根部门包含企业下所有成员。",
      tip2:
        "IDaaS支持同一账户有多个部门。当多个部门是上下级关系时，账户部门信息仅显示最下级部门。",
      tip3: "IDaaS支持基于部门授权，部门下所有成员将继承部门的授权信息。"
    }
  },
  computed: {
    departId() {
      return this.$route.query.departId
    },
    superId() {
      return this.$route.query.superId
    }
  },
  mounted() {
    if (this.departId && this.superId) {
      this.getDepartDetail()
      this.getDepartments()
      this.getDepartmentMembers()
      this.getDepartmentAuth()
    }
  },
  methods: {
    // 获取部门列表
    async getDepartments() {
      let { status, data } = await APIS.getDepartments(this.realmName)
      this.department = []
      if (status === 0) {
        this.department = this.formatSubgroups(JSON.parse(JSON.stringify(data)))
        this.setDepartmentData = this.formatSubgroups1(
          JSON.parse(JSON.stringify(data))
        )
      }
    },
    // 获取部门详情
    async getDepartDetail() {
      let params = {
        parentId: this.superId
      }
      let { status, data } = await APIS.getDepartmentDetail(
        this.realmName,
        this.departId,
        {
          params
        }
      )
      if (status === 0) {
        this.departmentName = data && data.name
        this.formBase.name = data && data.name
        this.formBase.superName = data.parentId
        // 设置option选择的部门
        this.selectOption.id = data.parentId
        this.selectOption.value = data.parentId
        this.selectOption.label = data.parentName
        this.isRootDepart = data.path.split("/").length === 2
        this.activeName = this.isRootDepart ? "second" : "first"
        this.preParams = JSON.stringify(this.formBase)
        this.preDepartment = JSON.stringify(this.selectOption)
      }
    },
    // 编辑部门信息
    async putDepartmentDetail() {
      let params = {
        name: this.formBase.name,
        parentId:
          this.superId === this.formBase.superName
            ? null
            : this.formBase.superName
      }
      let { status } = await APIS.putDepartmentDetail(
        this.realmName,
        this.departId,
        {
          data: params
        }
      )
      if (status === 0) {
        this.isEdit = false
        this.preParams = JSON.stringify(this.formBase)
        this.preDepartment = JSON.stringify(this.selectOption)
        // 部门信息更新后，需要更新部门数据
        this.getDepartments()
      }
    },
    // 获取部门成员信息
    async getDepartmentMembers(value) {
      let params = {
        key: value || "",
        pageNum: this.page,
        pageSize: this.pageSize
      }
      let { status, data } = await APIS.getDepartmentMembers(
        this.realmName,
        this.departId,
        {
          params
        }
      )
      this.tableData = []
      this.total = 0
      if (status === 0) {
        this.total = data.totalCount
        this.tableData =
          data.data &&
          data.data.map(item => {
            return {
              id: item.id,
              accountName: item.accountname,
              name: item.username,
              email: item.email,
              phone: item.telephone,
              department: item.departments
            }
          })
      }
    },
    // 设置部门成员信息
    async putDepartmentMembers() {
      let params = {
        userIds: this.userIds,
        remDepartIds: this.remDepartIds,
        addDepartIds: this.addDepartIds
      }
      let { status } = await APIS.putDepartmentMembers(this.realmName, {
        data: params
      })
      if (status === 0) {
        this.$refs.dialogSetDepart.dialogSetDepartVisible = false
        this.getDepartmentMembers()
      }
    },
    // 获取部门授权应用信息
    async getDepartmentAuth() {
      let { status, data } = await APIS.getDepartmentAuthClients(
        this.realmName,
        this.departId
      )
      this.tableDataClient = []
      this.tableDataAllClient = []
      if (status === 0) {
        data.forEach(item => {
          let obj = {
            id: item.id,
            clientId: item.clientId,
            clientName: item.clientName,
            role: item.roles,
            authMark: item.authMark
          }
          this.tableDataAllClient.push(obj)
          if (item.authMark) {
            this.tableDataClient.push(obj)
          }
        })
      }
    },
    // 给部门授权应用
    async postDepartClients({ addCIds, remCIds }) {
      let params = {
        addCIds,
        remCIds
      }
      let { status } = await APIS.putDepartmentAuthClients(
        this.realmName,
        this.departId,
        { data: params }
      )
      if (status === 0) {
        this.$refs.AuthClientRoles.dialogAuthClient = false
        this.getDepartmentAuth()
      }
    },
    // 给应用授权角色
    async putDepAuthCliRoles({ clientId, addRoleMarks, remRoleMarks }) {
      let params = {
        addRoleMarks,
        remRoleMarks
      }
      let { status } = await APIS.putDepAuthCliRoles(
        this.realmName,
        this.departId,
        clientId,
        { data: params }
      )
      if (status === 0) {
        this.$refs.AuthClientRoles.dialogSetRoleVisible = false
        this.getDepartmentAuth()
      }
    },
    // 编辑基本信息
    editDepart() {
      this.isEdit = true
    },
    // 账户信息分页
    pageChange() {
      this.getDepartmentMembers()
    },
    // 给部门授权应用
    departClients({ addCIds, remCIds }) {
      this.postDepartClients({ addCIds, remCIds })
    },
    // 给账户应用授权角色
    depAuthCliRoles({ clientId, addRoleMarks, remRoleMarks }) {
      this.putDepAuthCliRoles({ clientId, addRoleMarks, remRoleMarks })
    },
    // 确认设置部门信息
    setDepartment({ remDepartIds, addDepartIds }) {
      this.remDepartIds = remDepartIds
      this.addDepartIds = addDepartIds
      this.putDepartmentMembers()
    },
    // 确认编辑
    submitForm() {
      this.$refs["formBase"].validate(valid => {
        if (valid) {
          if (this.preParams === JSON.stringify(this.formBase)) {
            this.isEdit = false
          } else {
            this.putDepartmentDetail()
          }
        }
      })
    },
    // 取消编辑
    handleCancel() {
      this.formBase = JSON.parse(this.preParams)
      this.selectOption = JSON.parse(this.preDepartment)
      this.isEdit = false
      this.$refs.formBase.resetFields()
    },
    // 打开设置所在部门弹窗
    setDepart() {
      if (this.userIds.length === 0) {
        this.$message.error({
          message: "请至少选择一个账户"
        })
        return false
      }
      this.$refs.dialogSetDepart.dialogSetDepartVisible = true
    },
    // tab切换
    handleClick() {
      this.formBase = JSON.parse(this.preParams)
      this.selectOption = JSON.parse(this.preDepartment)
      this.isEdit = false
      this.$refs.account.clearSelection()
      this.$refs.formBase && this.$refs.formBase.resetFields()
    },
    // 搜索部门账户信息
    handleSearch(value) {
      this.$refs.account.clearSelection()
      this.page = 1
      this.getDepartmentMembers(value)
    },
    // 选择的账户改变
    handleAccountSelectionChange(select) {
      this.userIds = select.map(item => item.id)
      this.selectAccount = [...select]
    },
    // 选择框搜索，触发tree搜索
    filterMethod(value) {
      this.$refs.departTree.filter(value)
    },
    // 部门过滤
    filterNode(value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },
    // 下拉框展示
    visibleChange(value) {
      if (value) {
        // 初始化tree搜索状态
        this.$refs.departTree.filter("")
        // 初始化tree选择的部门
        this.$refs.departTree.setCheckedNodes([this.selectOption])
        // 初始化tree选择的部门
        this.$refs.departTree.setCurrentNode(this.selectOption)
      }
    },
    // 部门树节点被点击触发
    handleNodeClick(currentNode) {
      if (currentNode.disabled) {
        this.$refs.departTree.setCurrentNode(this.selectOption)
        this.$refs.departTree.setCheckedNodes([this.selectOption])
        return false
      }
      // 设置option选择的部门
      this.selectOption.id = currentNode.id
      this.selectOption.value = currentNode.id
      this.selectOption.label = currentNode.name
      // 设置select选择的部门
      this.formBase.superName = currentNode.id
      // 设置tree选择的部门
      this.$refs.departTree.setCheckedNodes([currentNode])
      // 使 input 失去焦点，并隐藏下拉框
      this.$refs.departSelect.blur()
    },
    // 格式化部门
    formatDepart(department) {
      return department.length === 0
        ? ""
        : department.map(item => item.name).join("，")
    },
    // 如果subgroups为空数组，则删掉改字段
    formatSubgroups(data, flag) {
      data.forEach(item => {
        // 选择父级部门时，当前部门以及子部门不可选择
        if (flag || item.id === this.departId) {
          flag = true
        } else {
          flag = false
        }

        if (flag) {
          item.disabled = true
        }
        if (item.subGroups && item.subGroups.length !== 0) {
          this.formatSubgroups(item.subGroups, flag)
        } else {
          flag = false
          delete item.subGroups
        }
      })
      return data
    },
    // 如果subgroups为空数组，则删掉改字段
    formatSubgroups1(data, flag) {
      data.forEach(item => {
        if (item.subGroups && item.subGroups.length !== 0) {
          this.formatSubgroups1(item.subGroups, flag)
        } else {
          delete item.subGroups
        }
      })
      return data
    }
  }
}
</script>

<style lang="scss" scoped>
.departmentDetail {
  .name {
    margin-bottom: 16px;
  }
  .el-tabs {
    .authTip {
      display: flex;
      background-color: rgba(0, 112, 204, 0.05);
      font-size: 13px;
      color: #454647;
      padding: 10px;
      line-height: 22px;
      margin-bottom: 15px;
      align-items: center;
      i {
        margin-right: 10px;
        margin-left: 5px;
      }
    }
    &__content {
      .row-one {
        margin-bottom: 15px;
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      .el-button {
        &.editDepart {
          margin-bottom: 15px;
        }
      }
      .el-select {
        width: 100%;
      }
    }
  }
}
</style>
<style lang="scss">
.el-tree.selectDepartTree {
  .el-tree-node__content {
    .el-checkbox {
      display: none;
      &.is-disabled + .el-tree-node__label {
        cursor: not-allowed;
      }
    }
  }
}
</style>
